// frontend/src/utils/tutorialData.js
// Zentrale Datei mit Tutorial-Inhalten für alle Dashboard-Seiten

export const tutorialData = {
    dashboard: {
        title: 'Willkommen im Dashboard!',
        icon: 'dashboard',
        description: 'Dies ist deine zentrale Anlaufstelle. Hier findest du alle wichtigen Informationen auf einen Blick.',
        features: [
            { icon: 'rocket_launch', text: 'Quick-Links zu den wichtigsten Bereichen' },
            { icon: 'notifications_active', text: 'Aktuelle Mitteilungen und Hinweise' },
            { icon: 'trending_up', text: 'Statistiken und Aktivitäten' }
        ]
    },
    profile: {
        title: 'Dein Profil',
        icon: 'person',
        description: 'Hier verwaltest du deine persönlichen Daten, Kontoinformationen und Privatsphäre-Einstellungen.',
        features: [
            { icon: 'badge', text: 'Benutzername und E-Mail ändern' },
            { icon: 'photo_camera', text: 'Profilbild oder Avatar anpassen' },
            { icon: 'lock', text: 'Passwort und Sicherheit verwalten' }
        ]
    },
    notifications: {
        title: 'Mitteilungen',
        icon: 'notifications',
        description: 'Verwalte deine Benachrichtigungs-Einstellungen für Push-Nachrichten und E-Mails.',
        features: [
            { icon: 'smartphone', text: 'Push-Benachrichtigungen aktivieren' },
            { icon: 'mail', text: 'E-Mail-Benachrichtigungen konfigurieren' },
            { icon: 'tune', text: 'Kategorien einzeln ein-/ausschalten' }
        ]
    },
    'my-team-page': {
        title: 'Meine Seite',
        icon: 'public',
        description: 'Deine öffentliche Team-Seite verwalten. Hier bestimmst du, was Besucher über euch sehen.',
        features: [
            { icon: 'edit', text: 'Texte und Beschreibungen bearbeiten' },
            { icon: 'image', text: 'Bilder und Galerie verwalten' },
            { icon: 'visibility', text: 'Vorschau der öffentlichen Seite' }
        ]
    },
    events: {
        title: 'Event-Verwaltung',
        icon: 'event',
        description: 'Erstelle und verwalte Veranstaltungen für deine Gruppe.',
        features: [
            { icon: 'add', text: 'Neue Events erstellen' },
            { icon: 'people', text: 'Anmeldungen einsehen' },
            { icon: 'edit_calendar', text: 'Bestehende Events bearbeiten' }
        ]
    },
    blog: {
        title: 'Blog-Verwaltung',
        icon: 'article',
        description: 'Schreibe und bearbeite Blog-Beiträge für eure Website.',
        features: [
            { icon: 'edit_note', text: 'Neue Beiträge verfassen' },
            { icon: 'image', text: 'Bilder und Medien einfügen' },
            { icon: 'visibility', text: 'Entwürfe speichern oder veröffentlichen' }
        ]
    },
    'contact-requests': {
        title: 'Kontaktanfragen',
        icon: 'contact_mail',
        description: 'Bearbeite eingehende Kontaktanfragen von eurer Website.',
        features: [
            { icon: 'inbox', text: 'Neue Anfragen einsehen' },
            { icon: 'reply', text: 'Direkt per E-Mail antworten' },
            { icon: 'check_circle', text: 'Anfragen als bearbeitet markieren' }
        ]
    },
    users: {
        title: 'Benutzer-Verwaltung',
        icon: 'group',
        description: 'Verwalte alle Mitglieder, ihre Rollen und Berechtigungen.',
        features: [
            { icon: 'person_add', text: 'Neue Benutzer freischalten' },
            { icon: 'admin_panel_settings', text: 'Rollen und Berechtigungen zuweisen' },
            { icon: 'password', text: 'Passwort-Reset-Links senden' }
        ]
    },
    'admin-tools': {
        title: 'Admin-Tools',
        icon: 'build',
        description: 'Zusätzliche Verwaltungswerkzeuge für Administratoren.',
        features: [
            { icon: 'link', text: 'URL-Shortener für kurze Links' },
            { icon: 'vpn_key', text: 'Registrierungscodes erstellen' },
            { icon: 'analytics', text: 'Google Analytics & Schnittstellen' }
        ]
    },
    'my-children': {
        title: 'Meine Kinder',
        icon: 'family_restroom',
        description: 'Verwalte die Profile deiner bei uns angemeldeten Kinder.',
        features: [
            { icon: 'person_add', text: 'Kinder hinzufügen' },
            { icon: 'edit', text: 'Kontaktdaten aktualisieren' },
            { icon: 'event', text: 'Zu Events anmelden' }
        ]
    },
    'my-registrations': {
        title: 'Meine Anmeldungen',
        icon: 'assignment',
        description: 'Überblick über alle Event-Anmeldungen und deren Status.',
        features: [
            { icon: 'event_available', text: 'Kommende Events sehen' },
            { icon: 'pending', text: 'Anmeldestatus prüfen' },
            { icon: 'cancel', text: 'Anmeldungen stornieren' }
        ]
    },
    'learning-hub': {
        title: 'Lernportal',
        icon: 'school',
        description: 'Lerne alles über das Pfadfinderleben mit unserem interaktiven Handbuch und Prüfungen.',
        features: [
            { icon: 'menu_book', text: 'Handbuch mit allen Themen' },
            { icon: 'quiz', text: 'Wissenstests und Prüfungen' },
            { icon: 'emoji_events', text: 'Fortschritt und Abzeichen' }
        ]
    },
    'instagram-generator': {
        title: 'Instagram Post & Karussell Studio',
        icon: 'photo_camera',
        description: 'Erstelle mit KI-Unterstützung professionelle Instagram-Karussells und Grafiken im Stamm-Design.',
        features: [
            { icon: 'auto_awesome', text: 'KI Magic Studio für Text- und Folien-Entwürfe' },
            { icon: 'layers', text: 'Live Canvas im 4:5 Portraitformat (1080x1350px)' },
            { icon: 'download', text: 'PNG-Einzelexport oder vollständiger ZIP-Download' }
        ]
    },
    material: {
        title: 'Material- & Zeltverwaltung',
        icon: 'inventory_2',
        description: 'Verwalte Zelte, Jurten, Kohten, Kochgeschirr und Werkzeuge deines Stammes.',
        features: [
            { icon: 'category', text: 'Bestand nach Kategorien & Zuständen erfassen' },
            { icon: 'handshake', text: 'Ausleihen und Rückgaben an Leiter protokollieren' },
            { icon: 'build', text: 'Reparaturbedarf und Wartung im Blick behalten' }
        ]
    },
    finances: {
        title: 'Finanzen & Kassenbuch',
        icon: 'account_balance',
        description: 'Digitales Kassenbuch für Barkasse, Girokonto und Zeltlager-Abrechnungen.',
        features: [
            { icon: 'payments', text: 'Einnahmen und Ausgaben mit Belegen buchen' },
            { icon: 'savings', text: 'Lagerkassen und Budgets verwalten' },
            { icon: 'receipt_long', text: 'Berichte für Kassenprüfer exportieren' }
        ]
    },
    tasks: {
        title: 'Aufgaben & To-Dos',
        icon: 'task_alt',
        description: 'Aufgabenverteilung und Terminplanung für die Leiterrunde und den Vorstand.',
        features: [
            { icon: 'add_task', text: 'Aufgaben mit Fälligkeit und Priorität anlegen' },
            { icon: 'person_outline', text: 'Zuweisung an Gruppenleiter' },
            { icon: 'check_circle', text: 'Status in Echtzeit verfolgen' }
        ]
    },
    groups: {
        title: 'Gruppen & Stufen',
        icon: 'diversity_3',
        description: 'Strukturierte Übersicht über alle Wölflingsmeuten, Sippen, Runden und die Leiterrunde.',
        features: [
            { icon: 'group_add', text: 'Neue Gruppen und Stufen anlegen' },
            { icon: 'supervisor_account', text: 'Gruppenleiter zuweisen' },
            { icon: 'schedule', text: 'Treffzeiten und Gruppenräume hinterlegen' }
        ]
    },
    attendance: {
        title: 'Digitale Anwesenheitsliste',
        icon: 'fact_check',
        description: 'Erfasse die Anwesenheit bei wöchentlichen Gruppenstunden, Lagern und Aktionen in Sekundenschnelle.',
        features: [
            { icon: 'playlist_add', text: 'Neue Termine und Listen anlegen' },
            { icon: 'done_all', text: 'Schnellaktionen ("Alle anwesend") nutzen' },
            { icon: 'query_stats', text: 'Anwesenheitsquoten und Historie einsehen' }
        ]
    },
    'homepage-settings': {
        title: 'Startseiten-Baukasten',
        icon: 'web',
        description: 'Gestalte den öffentlichen Auftritt deines Stammes einfach per Drag & Drop.',
        features: [
            { icon: 'view_agenda', text: 'Sektionen sortieren und aktivieren' },
            { icon: 'palette', text: 'Farbschema und Dark Mode anpassen' },
            { icon: 'publish', text: 'Änderungen sofort live veröffentlichen' }
        ]
    },
    integrations: {
        title: 'Schnittstellen & Secrets',
        icon: 'integration_instructions',
        description: 'Verbinde externe Dienste für E-Mail-Versand, KI-Modelle und Cloud-Hosting.',
        features: [
            { icon: 'mail', text: 'Resend E-Mail API für System-Mails' },
            { icon: 'psychology', text: 'Google Gemini für Bob & Texterstellung' },
            { icon: 'cloud_sync', text: 'Cloudflare D1 Datenbank & DNS' }
        ]
    },
    'bob-settings': {
        title: 'Bob KI-Assistent',
        icon: 'smart_toy',
        description: 'Konfiguriere den digitalen Pfadfinder-Assistenten Bob und trainiere ihn mit Stammeswissen.',
        features: [
            { icon: 'chat', text: 'Persönlichkeit und Tonalität einstellen' },
            { icon: 'menu_book', text: 'Stammeswissen und FAQ hinterlegen' },
            { icon: 'public', text: 'Auf Website und im Dashboard freischalten' }
        ]
    },
    'registration-codes': {
        title: 'Einladungscodes',
        icon: 'confirmation_number',
        description: 'Generiere Codes, mit denen neue Leiter oder Eltern direkt beitreten können.',
        features: [
            { icon: 'key', text: 'Codes mit Rollen und Gruppen erstellen' },
            { icon: 'qr_code_2', text: 'QR-Codes zum Scannen auf Leiterrunden' },
            { icon: 'history', text: 'Einlösungen und Limits überwachen' }
        ]
    }
};

// Hilfsfunktion zum Prüfen ob Tutorial schon gesehen wurde
export const hasSeenTutorial = (pageId) => {
    return localStorage.getItem(`tutorial_seen_${pageId}`) === 'true';
};

// Hilfsfunktion zum Markieren eines Tutorials als gesehen
export const markTutorialSeen = (pageId) => {
    localStorage.setItem(`tutorial_seen_${pageId}`, 'true');
};

// Hilfsfunktion zum Zurücksetzen aller Tutorials
export const resetAllTutorials = () => {
    Object.keys(tutorialData).forEach(key => {
        localStorage.removeItem(`tutorial_seen_${key}`);
    });
};
